import { UserShortDTO } from 'interfaces/users/users'

export const getFullNameUserShortDTO = (user: UserShortDTO) =>
  user?.firstName || user?.lastName ? `${user?.firstName || ''} ${user?.lastName || ''}` : user?.email
